
  import { css } from 'lit';
  export const styles = css`:host{background:var(--ranges-background);border-top:.0625rem solid var(--ranges-border)}`;
  